import { OfflineConstants } from '../offline/constants';
import { deleteStoreItem, getAllStoreItems, getStoreItem, putStoreItem } from '../offline/offlineApi';

export const getReportEventsItem = async (key) => await getStoreItem(OfflineConstants.stores.reportEvents.storeName, key);
export const getAllReportEventsItems = async () => await getAllStoreItems(OfflineConstants.stores.reportEvents.storeName);
export const putReportEventsItem = async (storeItem, key) => await putStoreItem(OfflineConstants.stores.reportEvents.storeName, storeItem, key);
export const deleteReportEventsItem = async (key) => await deleteStoreItem(OfflineConstants.stores.reportEvents.storeName, key);
